var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-logged-form__item"},[_c('label',{staticClass:"typo__label"},[_vm._v(_vm._s(_vm.$t('organization_name'))+"*")]),_c('input',{staticClass:"control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.firmTitle}})])
}
var staticRenderFns = []

export { render, staticRenderFns }